import { searchPeers } from '../../../actions/odooFormActions';
import { dhbs, tas, types } from '../../../utils/optionUtils';
import SelectField from '../formFields/SelectField';
import TextField from '../formFields/TextField';
import SearchVolunteerPeerResults from './SearchVolunteerPeerResults';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';

const limit = 20;

const SearchVolunteerPeerForm = ({ searching, sessionId, searchPeers }) => {
  const [page, setPage] = useState(0);
  const lastValuesRef = useRef(null);

  const onPageChange = (newPage) => {
    if (!lastValuesRef.current) return;
    const values = { ...lastValuesRef.current, start: lastValuesRef.current.limit * newPage };
    searchPeers(sessionId, values);
    setPage(newPage);
  };

  return (
    <div className="container content">
      <div className="bg-light-grey">
        <Form
          initialValues={{
            limit,
            EligibleOnly: 1,
            start: 0,
            Volunteer: 1,
            sessionId,
          }}
          onSubmit={(values) => {
            lastValuesRef.current = values;
            searchPeers(sessionId, values);
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field name="sessionId" component="input" type="hidden" />
              <section className="search">
                <div className="row">
                  <div className="col-md-4">
                    <div className="inner">
                      <span className="icon fi fi-stack fi-lg">
                        <i className="fi fi-circle fi-stack-2x"></i>
                        <i className="fi fi-search fi-stack-1x"></i>
                      </span>
                      <div className="heading">
                        <h3 className="lead-in">Find a volunteer professional peer</h3>
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <Field
                      name="Practice"
                      component={SelectField}
                      label="Search all or filter by type of practice"
                      cssClass="no-indent"
                      autocomplete={true}
                      options={types}
                    />
                    <Field name="City" component={TextField} label="Search by city or part of city" cssClass="no-indent" type="text" />
                    <Field
                      name="Suburb"
                      component={TextField}
                      label="Search by suburb or part of suburb"
                      cssClass="no-indent"
                      type="text"
                    />
                    <Field
                      name="TA"
                      component={SelectField}
                      label="Filter by territorial authority"
                      cssClass="no-indent"
                      autocomplete={true}
                      options={tas}
                    />
                    <Field
                      name="DHB"
                      component={SelectField}
                      label="Filter by public health district"
                      cssClass="no-indent"
                      autocomplete={true}
                      options={dhbs}
                    />

                    <div className="search-actions-volunteer-pair">
                      <button className="btn btn-primary" disabled={searching} type="submit">
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </form>
          )}
        />
      </div>

      <SearchVolunteerPeerResults limit={limit} onPageChange={onPageChange} searching={searching} page={page} />
    </div>
  );
};

SearchVolunteerPeerForm.propTypes = {
  peers: PropTypes.array,
  searching: PropTypes.bool,
  sessionId: PropTypes.string,
  searchPeers: PropTypes.func,
};

const mapStateToProps = (state) => ({
  searching: state.odooForm.searching,
  sessionId: state.user.sessionId,
});

export default connect(mapStateToProps, { searchPeers })(SearchVolunteerPeerForm);
